var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13642 1.24425H0.622127C0.278278 1.24425 0 0.965962 0 0.622127C0 0.278292 0.278293 0 0.622127 0H8.13642C8.48026 0 8.75854 0.278292 8.75854 0.622127C8.75854 0.96586 8.48025 1.24425 8.13653 1.24425H8.13642Z",
    fill: "#143232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3779 6.64684H0.622127C0.278278 6.64684 0 6.36855 0 6.02472C0 5.68088 0.278293 5.40259 0.622127 5.40259L11.3779 5.4027C11.7217 5.4027 12 5.68099 12 6.02483C11.9999 6.36856 11.7216 6.64684 11.3779 6.64684V6.64684Z",
    fill: "#143232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13642 12.0492H0.622127C0.278278 12.0492 0 11.7709 0 11.4271C0 11.0832 0.278293 10.8049 0.622127 10.8049H8.13642C8.48026 10.8049 8.75854 11.0832 8.75854 11.4271C8.75854 11.7709 8.48025 12.0492 8.13653 12.0492H8.13642Z",
    fill: "#143232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.e6f47320ef0cca78e0eb669025c4b861.svg";
export { ForwardRef as ReactComponent };